import Main from "./pages/main.js"

// bootstrap CSS and JS
// https://getbootstrap.com/
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

function App() {
  return ( 
    <>
      <Main />
    </>
  );
}

export default App;
